document.addEventListener("DOMContentLoaded", function () {

  const filterBar = document.querySelector("[data-ajax-filter-bar]");
  if (!filterBar) return;

  const productGrid = document.querySelector("[data-products-grid]");
  const productCount = document.querySelector("[data-product-count]");

  function applyFilters() {
    let params = new URLSearchParams(window.location.search);

    // Availability
    let availability = [...document.querySelectorAll("input[name='availability']:checked")].map(i => i.value);
    if (availability.length)
      params.set("availability", availability.join(","));
    else
      params.delete("availability");

    // Colors
    let colors = [...document.querySelectorAll("input[name='color']:checked")].map(i => i.value);
    if (colors.length)
      params.set("color", colors.join(","));
    else
      params.delete("color");

    // Sort
    let sort = document.querySelector("input[name='sort_by']:checked");
    if (sort)
      params.set("sort_by", sort.value);

    // Price
    let min = document.querySelector("input[name='price_min']").value;
    let max = document.querySelector("input[name='price_max']").value;
    if (min) params.set("min_price", min);
    if (max) params.set("max_price", max);

    // Update URL
    let newUrl = `${window.location.pathname}?${params.toString()}`;
    
    fetch(newUrl + "&section_id=main-collection-product-grid")
      .then(res => res.text())
      .then(html => {
        let div = document.createElement("div");
        div.innerHTML = html;

        let newProducts = div.querySelector("[data-products-grid]");
        let newCount = div.querySelector("[data-product-count]");

        productGrid.innerHTML = newProducts.innerHTML;
        productCount.innerHTML = newCount.innerHTML;

        window.history.replaceState({}, "", newUrl);
      });
  }

  // Price apply button
  document.querySelector(".pf-apply-price")?.addEventListener("click", applyFilters);

  // All checkboxes
  document.querySelectorAll(".pf-menu input").forEach(input => {
    input.addEventListener("change", applyFilters);
  });

});
